define('modules/home/main/views/history.item.view',[
    'jquery',
    'underscore',
    'backbone',
    "text!modules/home/main/templates/history.item.template.html"
], function(
    $,_,Backbone,
    Template
){
    var HistoryItemView = Backbone.View.extend({
        className: 'homeActivity animated slideInUp',
        template: _.template(Template),
        events: function(){
            var base = {
            };
            var click = {
                    'click'  : 'clickURL'
                };
            $.extend(base,click);
            return base;

        },
        initialize: function(options) {
            this.identity = options.identity;
        },
        render: function() {
            $(this.el).html(this.template());
            this.$('.homeActivityLine1').html(this.identity.name);
            this.$('.homeActivityLine1').attr("href", '#' + this.buildURL());
            switch(this.identity.itemType) {
                case "person":
                {
                    var parts = this.identity.headline.split("-");
                    this.$('.homeActivityLine2').html(parts[0]);
                    this.$('.homeActivityLine3').html(parts[1]);
                    this.$('.homeActivityIcon').addClass('relpro').addClass('relpro-person_silo');
                    break;
                }
                case "list":
                {
                    this.$('.homeActivityIcon').addClass('icon-lists');
                    //this.$('.homeActivityLine1').addClass('mTop10');
                    break;
                }
                default:
                {
                    // Uncomment the logo download when the history endpoint includes a url or a headline with a url

                    //var logoUrl = window.utils.identity.getDomain(this.identity.headline);
                    //if (logoUrl) {
                    //    this.$('.homeActivityIcon').html('<img class="companyLogo" src="https://s3.amazonaws.com/relpro-company-logos/' + logoUrl + '.png">');
                    //} else {
                    //    this.$('.homeActivityIcon').addClass("icon-building");
                    //}

                    this.$('.homeActivityIcon').addClass('relpro').addClass('relpro-building');
                    break;
                }
            }
            return this;
        },
        buildURL: function() {
            if(this.identity.itemType == "list"){
                this.clickUrl = 'list/' + this.identity.source.sourceId + '/' + this.identity.source.refId;
            } else{
                this.clickUrl = 'profile/' + this.identity.itemType + '/' + this.identity.source.sourceId + '/' + this.identity.source.refId;
            }
            return this.clickUrl;
        },

        clickURL:function(){
            if(this.identity.itemType == "list"){
                this.clickUrl = 'list/' + this.identity.source.sourceId + '/' + this.identity.source.refId;
            } else{
                this.clickUrl = 'profile/' + this.identity.itemType + '/' + this.identity.source.sourceId + '/' + this.identity.source.refId;
            }
            Backbone.history.navigate(this.clickUrl,true);
        }
    });
    return HistoryItemView;
});

